import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./DashboardForm.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import Form from '/src/components/form/Form';

import Dropdown from '/src/components/UI/DropDown/DropDown';
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import TextInput from '/src/components/UI/TextField/TextInput';
import TextArea from '/src/components/UI/TextField/TextArea';
import botService from '/src/features/bot/services/botService'
import IconsChannels from '../../../../phone/data/types/Icons';
import Field from '/src/components/UI/Field/Field';
import Storage from "/src/utils/storage";
import Button from "/src/components/UI/Button/Button";
import { useForm } from 'react-hook-form';
import clientSvg from "/src/assets/img/svg/client.svg"
import capitalizeFirstLetter from "/src/utils/capitalizeFirstLetter";

import "/src/assets/css/polices.css"
import "./DashboardForm.css"
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import DashboardFormType from "./DashboardFormType";
import companyService from "/src/features/administration/company/services/companyService";
import { updateSharedDashboardForm, addDashboardForm, updateDashboardForm } from "./DashboardSubmitFormUtils";

import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import dashboardService from "../../services/dashboardService";

function DashboardForm({ data, type }) {
    var dashboard = data?.dashboard;

    const navigate = useNavigate();
    const dataType = DashboardFormType[type ? type : "create"];
    const isShared = data?.origin == 0;
    const { register, handleSubmit, watch, formState: { errors }, formState, getValues, setValue } = useForm({
        mode: "onChange",
        defaultValues: {
            bot_id: dashboard ? dashboard.bot.id : "",
            name: dashboard ? (isShared && data.name != null ? data.name : dashboard.name) : "",
            description: dashboard ? (isShared && data.description != null ? data.description : dashboard.description) : "",
        }
    });

    const [listCheckedCompany, setListCheckedCompany] = useState([])
    const [listRemovedSharedDash, setListRemovedSharedDash] = useState([])

    const [listCheckedChannel, setListCheckedChannel] = useState([])

    //const { bots } = useBots();
    const { getChannelsAvailableForDashboard } = dashboardService;
    const { getBots } = botService;
    const { getCompaniesWithoutPagination } = companyService;
    const [bots, setBots] = useState("");
    const [channels, setChannels] = useState("")
    const [companies, setCompanies] = useState("")
    const storage = Storage('session');


    //console.log(data)
    const onSubmit = async () => {

        var dataToSend = getValues();
        dataToSend.company_ids = listCheckedCompany.map(company => { 
            if (company == null) return;
            if (company.id_shared == null) return company.id 
        }).filter(_id => _id !== undefined);
        dataToSend.channel_ids = listCheckedChannel;
        dataToSend.removed_dashboard_id = listRemovedSharedDash;

        let res = null;
        if (dashboard == null) {
            res = await addDashboardForm(dataToSend)
        }
        else if (isShared == true) { // shared dashboard submit
            res = await updateSharedDashboardForm(dataToSend, data.id)
        }
        else {
            res = await updateDashboardForm(dataToSend, data.id)
        }
        return navigate(urlWithRoutingCompany(res));
    }

    const getAllBots = async () => {
        let [response, error] = await getBots()
        if (error !== null) {
            console.log(error);
            return;
        }
        setValue("bot_id", dashboard ? dashboard.bot.id : response[0]?.id)
        setBots(setUpBots(response));
    }
    const getAllChannels = async (bot_id) => {
        let params = {
            bot_id: bot_id
        }
        if (data != null) {

            params.dashboard_channel_id = data.id; // important pour les conflits
            params.company_id = data.company_id; // si on arrive dans le update depuis la page Plug and Play, permet de voir les bons channels
        }
        let [response, error] = await getChannelsAvailableForDashboard(params)
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = data ? data.dashboards_channels_links.map(channel_link => channel_link.channel_id) : [];
        setListCheckedChannel(res);
        setChannels([...response]);

    }
    const getAllCompanies = async () => {
        let [response, error] = await getCompaniesWithoutPagination()
        if (error !== null) {
            console.log(error);
            return;
        }
        setCompanies(response); // when the companies are retrieved, we have to check if one or many have shared dashboard (update)
        if (data == null) return;

        let res = data.shared_dashboards.map(shared => {
            if (shared.company == null) return null;   
            shared.company.base_dashboard = true
            shared.company.id_shared = shared.id
            return shared.company
        });
        setListCheckedCompany(res);
    }
    const setUpBots = (tmpBots) => tmpBots.map(bot => {
        return {
            value: bot.id,
            text: <span style={{ maxWidth: "300px" }}> <i style={{ marginRight: '15px' }} className={'flag-icon flag-icon-' + bot.language.slug.toLowerCase()}></i> <div className="dashboard_content_dropdown"> {bot.name} </div> </span>
        }
    })

    const addCompanySharing = (_company) => {
        if (_company == null) return; 
        _company.base_dashboard = false;
        let array = [...listCheckedCompany, _company];
        array = array.sort((a, b) => a?.name < b?.name ? -1 : 1);
        setListCheckedCompany(array)
    }

    const checkChannel = (_channel_id) => {
        let result = listCheckedChannel;
        let color = "";
        let icon = "";
        if (result.filter((id) => { return id == _channel_id; }).length == 0) { // if dataset is not checked
            result.push(_channel_id);
            color = "var(--green)";
            icon = "fas fa-check-circle";
        }
        else { // if dataset is already checked
            color = "var(--main)";
            icon = "fas fa-plus-circle";
            let index = listCheckedChannel.findIndex(id => id === _channel_id);
            result.splice(index, 1)
        }
        document.getElementById(_channel_id + "button").style.color = color
        document.getElementById(_channel_id + "button").children[0].classList = icon
        setListCheckedChannel([...result])
    }

    const deleteCompanyShared = (index, id_shared) => {
        if (id_shared != null) {
            setListRemovedSharedDash([...listRemovedSharedDash, data.shared_dashboards.find(shared => id_shared == shared.id).id])
        }
        setListCheckedCompany(companies => {
            return companies.filter((_, i) => i !== index)
        })
    }

    useEffect(() => {
        getAllBots();
        getAllCompanies();
    }, [])

    useEffect(() => {
        let bot_id = getValues("bot_id");
        if (bot_id) {
            getAllChannels(bot_id)
        }
    }, [bots])
    return (
        <Form onSubmit={handleSubmit(onSubmit)} className="main_container_form_dashboard">
            <Form.Title>{dataType.title}</Form.Title>
            <Form.Body className="body_form_dashboard">
                <Slider className="slider_dashboard_form">

                    <Slide name="main_form" className={"slide_dashboard_form"}>
                        {
                            type == null ?
                                <div className="container_line_dropdown_dashboard">
                                    <Field label="Select a bot" listLabelClassName="titles-input"></Field>
                                    {
                                        Array.isArray(bots) && bots.length > 0 ?
                                            <div className="container_dropdown_dashboard" style={{ marginRight: 70 }} >
                                                <Dropdown {...register('bot_id')} setValue={(name, value) => { setValue(name, value); setValue("channel", -1); getAllChannels(value) }} choices={bots} width="280px" defaultChoice={dashboard ? dashboard.bot_id : bots[0]?.value}></Dropdown>
                                            </div>
                                            : null
                                    }
                                </div>
                                :
                                <>
                                    {data?.origin == 0 &&
                                        <div className="information_message" style={{ marginLeft: "2%", width: "75%", marginBottom: "0" }}>  Shared By : {capitalizeFirstLetter(dashboard.company.name)}</div>
                                    }
                                    <div className="container_line_dropdown_dashboard" style={{ justifyContent: "start" }}>
                                        <Field label="Related Bot : " listLabelClassName="titles-input"></Field>
                                        <Field label={<span style={{ fontWeight: "bold", marginLeft: "10px" }}>{capitalizeFirstLetter(dashboard.bot.name)} </span>} listLabelClassName="titles-input"></Field>
                                    </div>
                                </>
                        }

                        <div className="dashboard_form-container">
                            <Field label={<span>Dashboard {isShared ? " shared " : ""} name<span className="obligatory_field">*</span> </span>} listLabelClassName="titles-input">
                                <TextInput {...register('name', { required: true, minLength: 3 })} style={errors.name ? { borderColor: "red" } : {}} />
                                <span className='error'>{errors.name ? (errors.name.message ? errors.name.message : "At least 3 letters") : ""}</span>
                            </Field>
                        </div>
                        <div className="dashboard_form-container">
                            <Field label="Enter a description" listLabelClassName="titles-input">
                                <TextArea style={{ height: "70px"/*'40px'*/ }} {...register('description', { required: false })}></TextArea>
                            </Field>
                        </div>
                        { /*   <br /> */}
                        {
                            /*
                        <div className="container_line_dropdown_dashboard" style={{ marginRight: 30 }}>
                            {
                                Array.isArray(channels.dropdown) && channels.dropdown.length > 1 ?
                                    watch("bot_id") &&
                                    <>
                                        <Field label={<span><abbr title="Optionnal while you don't put the dashboard in production" style={{ marginRight: "15px", width: "100%" }}> Select a channel </abbr></span>} listLabelClassName="titles-input"></Field>

                                        <div className="container_dropdown_dashboard" style={{ marginRight: 70 }} >

                                            <Dropdown {...register('channel_id')} setValue={setValue} choices={channels.dropdown} width="280px" defaultChoice={data && data.channel_id ? data.channel_id : (watch("channel_id") == null ? -1 : watch("channel_id").value)} reverse={true}></Dropdown>
                                        </div>

                                    </>
                                    :
                                    channels.length == 1 &&
                                    <span className="error" style={{ textAlign: 'left', fontSize: "18px" }}> No channel is connected to this bot for the moment </span>
                            }
                        </div>
                        
                        */
                        }
                        {
                            Array.isArray(channels.list) && channels.list.find(x => x.id == watch("channel_id"))?.is_available == false &&
                            <span className="error" style={{ textAlign: 'left', fontSize: "18px", width: "85%", paddingLeft: "0" }}> There is conflicts between dashboards </span>
                        }
                        <div className="dashboard_form_advanced_parameters" onClick={() => ScrollIntoSlide("channels_section")}> Select channel(s) <i class="fas fa-arrow-right" style={{ marginLeft: "5px", marginTop: "25px" }}></i></div>
                    </Slide>
                    <Slide name="channels_section" className={"slide_dashboard_form_channel"}>
                        <br />
                        {
                            listCheckedChannel.length == 0 &&
                            <div className="information_message">
                                <i className="fas fa-info-circle" style={{ marginRight: "15px" }}></i>
                                Your dashboard is not use on any channel. If you want to link your dashboard to a channel to use it, please check the list below
                            </div>
                        }
                        {
                            <div style={{ height: listCheckedChannel.length == 0 ? "50%" : "70%" }}>
                                <Field label={"Link the dashboard to the channel(s)"} listLabelClassName="titles-input" />
                                {channels != null && Array.isArray(channels) &&
                                    <div className="dashboard_container_list" style={{ height: "100%" }}>
                                        {channels.map((_channel, i) => {
                                            let bool = listCheckedChannel.includes(_channel.id)
                                            return (
                                                <div id={_channel.id + "container"} className="dashboard_list_companies" data-checked="false" data-id={_channel.id} style={{ border: _channel.is_available ? (bool ? "2px solid var(--main)" : "") : "2px solid var(--pink)" }}>
                                                    <div className={"dashboard_list_channel_container"}>

                                                        <img srcSet={IconsChannels[_channel.type.name]}></img>
                                                        {_channel.name}
                                                    </div>
                                                    <div>
                                                        {
                                                            _channel.is_available ?
                                                                <div class='buttonWrap'>
                                                                    <IconButton id={_channel.id + "button"} className="main-iconButton add-hover modalButtons-input" icon={bool ? "fas fa-check-circle" : "fas fa-plus-circle"} style={{ color: bool ? "var(--green)" : "var(--main)" }} onClick={(e) => checkChannel(_channel.id)} />
                                                                </div>
                                                                :
                                                                <span style={{ color: "var(--pink)", marginRight: "10px" }}>Conflict·s</span>
                                                        }

                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                }
                            </div>
                        }
                        <br />
                        <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
                            <div className="dashboard_form_advanced_parameters" onClick={() => ScrollIntoSlide("main_form")}> <i class="fas fa-arrow-left" style={{ marginRight: "10px", marginTop: "25px" }}></i>Main parameters</div>

                            {isShared == false &&
                                <div className="dashboard_form_advanced_parameters" onClick={() => ScrollIntoSlide("share_company")}>Share Dashboard <i class="fas fa-arrow-right" style={{ marginLeft: "5px", marginTop: "25px" }}></i></div>
                            }
                        </div>
                    </Slide>

                    {isShared == false &&

                        <Slide name="share_company" className={"slide_dashboard_form"}>
                            <br />
                            <Field label={"Companies with their own instance of your dashboard"} listLabelClassName="titles-input" />
                            {
                                listCheckedCompany.length != 0 &&
                                <div className="dashboard_container_list">
                                    {
                                        listCheckedCompany.map((_company, i) => {
                                            if (_company == null) return <></>;
                                            let full_name = _company.id_shared ? " - " + data.shared_dashboards.find(shared => _company.id_shared == shared.id).name : ""
                                            return (
                                                <div id={_company.id + "container"} className="dashboard_list_companies" data-checked="false" data-id={_company.id} style={{ padding: "5px" }}>
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <i className="fas fa-building"></i>
                                                        <div>
                                                            {_company.name} {full_name}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div class='buttonWrap'>
                                                            <IconButton id={_company.id + "button"} className="main-iconButton red-button modalButtons-input" icon="fas fa-trash" onClick={(e) => deleteCompanyShared(i, _company.id_shared)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }

                            {
                                listCheckedCompany.length == 0 &&
                                <div className="information_message">
                                    <i className="fas fa-info-circle" style={{ marginRight: "15px" }}></i>
                                    Your dashboard is not shared to any company. If you want to duplicate your dashboard and handle an instance of it to another company, please check the list below
                                </div>
                            }
                            <br />
                            {
                                (dashboard == null || (!isShared == 1)) &&
                                <>
                                    <Field label={"Share a new instance to other companies"} listLabelClassName="titles-input" />
                                    {companies != null && Array.isArray(companies) &&
                                        <div className="dashboard_container_list">
                                            {companies.map((_company, i) => {
                                                let bool = data?.shared_dashboards.some(dash => dash.company_id == _company.id);
                                                return (
                                                    <div id={_company.id + "container"} className="dashboard_list_companies" data-checked="false" data-id={_company.id} style={{ border: bool ? "2px solid var(--main)" : "", backgroundColor: bool ? "var(--secondary)" : "" }}>
                                                        <div>
                                                            <i className="fas fa-building"></i>
                                                            {_company.name}
                                                        </div>
                                                        <div>
                                                            <div class='buttonWrap'>
                                                                <IconButton id={_company.id + "button"} className="main-iconButton add-hover modalButtons-input" icon="fas fa-plus-circle" onClick={(e) => addCompanySharing(_company)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    }
                                </>
                            }
                            <div className="dashboard_form_advanced_parameters" onClick={() => ScrollIntoSlide("channels_section")}> <i class="fas fa-arrow-left" style={{ marginRight: "10px", marginTop: "25px" }}></i>Select channel(s)</div>

                        </Slide>
                    }
                </Slider >
            </Form.Body >
            <Form.Buttons className="dashboard_last_row">

                <Button type="submit" label={dataType.send} className="validate" disabled={formState.isValid == false || (Array.isArray(channels.list) && channels.list.find(x => x.id == watch("channel_id"))?.is_available == false) ? true : false} />
            </Form.Buttons>
        </Form >

    );
}

export default DashboardForm;